import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { Navigation, Pagination, Autoplay } from "swiper/modules"

export default class extends Controller {
  static targets = ["prev", "next", "pagination"]

  connect() {
    this.swiper = new Swiper(this.element.querySelector(".slider-swiper"), {
      modules: [Navigation, Pagination, Autoplay],
      loop: true,
      speed: 700,
      spaceBetween: 30,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      navigation: {
        prevEl: this.prevTarget,
        nextEl: this.nextTarget
      },
      pagination: {
        el: this.paginationTarget,
        clickable: true,
        bulletClass: "slider-dot",
        bulletActiveClass: "slider-dot-active",
        renderBullet: (_index, className) => {
          return `<button type="button" class="${className}" aria-label="Go to slide"></button>`
        }
      }
    })
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy()
      this.swiper = null
    }
  }
}
